<template>
<b-container class="user-add-container create-account-container" v-if="user != null && loaded">
<b-row v-show="submissionStatus == 'submission-success'">
	<b-col>
		<h1>Your account has been created.</h1>
		<p>Proceed to log into Winnipeg Lane Closures</p>
		<b-button @click="goToHome" variant="primary">Log In</b-button>
	</b-col>
</b-row>
<b-form @submit="onSubmit" @reset="onReset" v-show="submissionStatus != 'submission-success'">
	<h1>Create Your Lane Closures Account</h1>
	<b-row>
		<b-col lg="6">
			<b-form-group label="Username"
				@click="focusUsernameField"
				:state="usernamePrefix.status"
				:invalid-feedback="usernamePrefix.invalidMessage"
				class="lc__username"
			>
				<p class="username-info">The organization suffix '<strong>{{ organizationSuffix }}</strong>' will be part of your username.</p>
				<div @click="focusUsernameField" id="username-editable-content" class="form-control">
					<span id="username-prefix" class="editable" @keydown="handleLCKeypress" @focus="setFocusStyle" @blur="removeUsernameFocus" @input="setNewUsername" contenteditable="true" v-html="usernamePrefix.value"></span>
					<span id="username-postfix" class="non-editable">{{ organizationSuffix.trim() }}</span>
				</div>
					<!-- <b-input-group :append="organizationSuffix">
						<b-form-input placeholder="User Name" v-model="usernamePrefix.value"
							:state="usernamePrefix.status"
							:invalid-feedback="usernamePrefix.invalidMessage"
							@input="usernamePrefix.resetStatus()"
						></b-form-input>
					</b-input-group> -->
			</b-form-group>


			<b-form-group label="Set Password"
				:state="user.password.status"
				:invalid-feedback="user.password.invalidMessage"
			>
			<b-input-group>
			<b-form-input
				v-model="user.password.value"
				id="password"
				:strength="passwordStrength"
				:type="passwordFieldType"
				@input="updatePasswordStrength"
				autocomplete="off"
			/>
			<b-input-group-append>
			<b-button variant="secondary" @click="switchPasswordVisibility()">show/hide</b-button>
			</b-input-group-append>
			</b-input-group>
			</b-form-group>

		</b-col>
		<b-col lg="6">

			<b-form-group label="First Name"
				:state="user.firstName.status"
				:invalid-feedback="user.firstName.invalidMessage"
			>
			<b-form-input placeholder="First Name" v-model="user.firstName.value"
				:state="user.firstName.status"
				@input="user.firstName.resetStatus()"
			></b-form-input>
			</b-form-group>
			<b-form-group label="Last Name"
				:state="user.lastName.status"
				:invalid-feedback="user.lastName.invalidMessage"
			>
			<b-form-input placeholder="Last Name" v-model="user.lastName.value"
				:state="user.lastName.status"
				@input="user.lastName.resetStatus()"
			></b-form-input>
			</b-form-group>

			<b-form-group label="Title"
				:state="user.title.status"
				:invalid-feedback="user.title.invalidMessage"
			>
			<b-form-input placeholder="Title" v-model="user.title.value"
				:state="user.title.status"
				@input="user.title.resetStatus()"
			></b-form-input>
			</b-form-group>

			<b-form-group label="Email Address"
				:state="user.email.status"
				:invalid-feedback="user.email.invalidMessage"
			>
			<b-form-input type="email" placeholder="Email Address" v-model="user.email.value"
				:state="user.email.status"
				@input="user.email.resetStatus()"
			></b-form-input>
			</b-form-group>
			<b-form-group label="Primary Phone"
				:state="user.phone.status"
				:invalid-feedback="user.phone.invalidMessage"
			>
			<b-input id="createAccountFromPinPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="user.phone.value" placeholder="1-###-###-####"/>
			</b-form-group>
			<b-form-group label="Alternate Phone"
				:state="user.altPhone.status"
				:invalid-feedback="user.altPhone.invalidMessage"
			>
			<b-input id="createAccountFromPinAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="user.altPhone.value" placeholder="1-###-###-####"/>
			</b-form-group>
		</b-col>
	</b-row>

<b-row>
	<b-col lg="6"></b-col>
	<b-col lg="6">
		<b-button variant="primary" type="button" @click="onSubmit">Create My Account <b-spinner small label="Saving..." class="ml-2" v-if="saving" /></b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

</b-form>
</b-container>
</template>


<script>
import CreateAccount from '../../models/CreateAccount';
// import Autocomplete from '@trevoreyre/autocomplete-vue'
import BootstrapField from '../../utility/BootstrapField';
import ErrorHandler from '../../utility/ErrorHandler';
// import Treeselect from '@riophae/vue-treeselect'
// import { VuePassword } from '../../components/vue-password'
// import Format from '../../utility/Format';
import User from '../../models/User';

import Vue from 'vue'
// import { mapGetters } from 'vuex';
// import { mapActions } from 'vuex';
// import { mapMutations } from 'vuex';

export default {
  name: 'AddUser',
  docTitle: "Create Account - Lane Closures",

  components: {
	// Treeselect,
// Autocomplete,
// VuePassword
  },
  props: ['jwt'],
  data() {
	return {
		Format,
		CreateAccount,
		editedUsername: '',
		user: null,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		passwordFieldType:"password",
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		selectSupervisor:new BootstrapField({
					value: null,
		}),
		selectAlternate:new BootstrapField({
					value: null,
		}),
		selectAway:new BootstrapField({
					value: null,
		}),
		showRequiredFieldModal: false,
		requesterProjectIdOptions: [],
		supervisorInfo: null,
		alternateInfo: null,
		awayInfo: null,
		refSearchSupervisor: null,
		refSearchAlternate: null,
		refSearchAway: null,
		show: true,
		status:null,
		submissionStatus: null,
		showNewOrganizationModal: false,
		organizationInfo:null,
		passwordStrength:0,
		confirmPasswordStrength:0,
		usernamePrefix:new BootstrapField({
					value: null, required:true,
					validator: function(value) {
						if (value == null || value == "null" || value == "") {
							return false;
						}
						return true;
					},
					invalidMessage: 'Please enter username',
				}),
		saving: false,
	}
	},
	mounted() {
		this.GetCreateAccountInfo();
   },
	computed: {
		organizationSuffix: function() {
			if (this.user) {
				if (this.user.domain.value) {
					return this.user.domain.value;
				}
			}

			return null
		}
	},

	watch: {
		'user.organizationId.value':function() {
			this.calculateUserName();
		},
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
		'user.phone.value':function() {
		}
	},

  methods: {
  	onPhoneFocus:function() {
  		if (this.user.phone.value == null || this.user.phone.value == "") {
  			setTimeout(function(){
  			      document.getElementById('createAccountFromPinPhone').value = "1-";
  			      document.getElementById('createAccountFromPinPhone').selectionStart = document.getElementById('createAccountFromPinPhone').value.length;
  			      document.getElementById('createAccountFromPinPhone').selectionEnd = document.getElementById('createAccountFromPinPhone').value.length;
  			    },1);  // call the function after 50ms
  		}
  	},
  	onPhoneBlur:function() {
  		if (this.user.phone.value == "1-" || document.getElementById('createAccountFromPinPhone').value == "1-") {
  			this.user.phone.value = null;
  			setTimeout(function(){
  			    document.getElementById('createAccountFromPinPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
  	onAltPhoneFocus:function() {
  		if (this.user.altPhone.value == null || this.user.altPhone.value == "") {
  				// this.user.altPhone.value = "1-";
  			setTimeout(function(){
  			      document.getElementById('createAccountFromPinAltPhone').value = "1-";
  			      document.getElementById('createAccountFromPinAltPhone').selectionStart = document.getElementById('createAccountFromPinAltPhone').value.length;
  			      document.getElementById('createAccountFromPinAltPhone').selectionEnd = document.getElementById('createAccountFromPinAltPhone').value.length;
  			    },1);  // call the function after 50ms

  		}
  	},
  	onAltPhoneBlur:function() {
  		if (this.user.altPhone.value == "1-" || document.getElementById('createAccountFromPinAltPhone').value == "1-") {
  			this.user.altPhone.value = null;
  			setTimeout(function(){
  			    document.getElementById('createAccountFromPinAltPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},

	handleLCKeypress: function(event) {
		if (event.key == " " || event.key == 'PageUp' || event.key == 'PageDown') {
			event.preventDefault();
		}
	},
	setUsernameValidateStyle() {
		document.getElementById('username-editable-content').classList.remove('is-invalid');
		document.getElementsByClassName('lc__username')[0].getElementsByClassName('invalid-feedback')[0].classList.remove('d-block');
		if(this.usernamePrefix.value == '') {
			document.getElementById('username-editable-content').classList.add('is-invalid');
		}
	},
	focusUsernameField(e) {
		document.getElementById('username-prefix').focus();
	},
	setFocusStyle() {
		requestAnimationFrame(() => document.execCommand('selectAll'));
		document.getElementById('username-editable-content').classList.add('focus');
	},
	setNewUsername(e) {
		this.editedUsername = e.target.innerText;
		if (e.target.innerText == "" && e.target.innerHTML != "")  {
			this.editedUsername = e.target.innerHTML;
		}
	},
	removeUsernameFocus() {
		if(this.editedUsername != 'INITIAL__DATA') {
			this.usernamePrefix.value = this.editedUsername.trim();
		} else {
			this.editedUsername = this.usernamePrefix.value;
		}
		this.setUsernameValidateStyle();
		document.getElementById('username-editable-content').classList.remove('focus');
	},
  	switchPasswordVisibility() {
  	  this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
  	},


	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},

	calculateUserName() {
		if (this.user) {
			if (this.usernamePrefix.value) {
				this.user.username.value = this.usernamePrefix.value + this.user.domain.value;
			} else {
				this.user.username.value = null;
			}
		} else {
			this.user.username.value = null;
		}
		// TODO: confirm that user name is not taken.
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		goToHome() {
			this.$router.push('/')
		},
		onSubmit(evt) {
			evt.preventDefault()
			if (this.validateFields()) {
			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.PostCreateAccount(that.user);
			});
			}
		},
		onReset(evt) {
			evt.preventDefault()
			// Trick to reset/clear native browser form validation state
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},
		PostCreateAccount(t) {
			this.saving = true;
			if (t instanceof CreateAccount) {
				Vue.prototype.$http.post(this.$store.state.apiUrl + '/create-account', t.getRawValue())
					.then(resp => {
						// Handle Success
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.saving = false;
						this.SaveNewSuccess();
						this.onSubmitPromiseDeferred.resolve();
					})
					.catch(error => {
						this.saving = false;
						this.isButtonDisabled = false;
						this.saving = false;
						this.loaded = false;
						if (error) {
							Vue.prototype.$bus.$emit("error:network", {error:error,submitted:t.getRawValue()});
							this.onSubmitPromiseDeferred.reject();
						}
					}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		PutUser(t) {
			if (t instanceof User) {
				Vue.prototype.$http.put({
					url: `${this.$store.state.apiUrl}/user/${t.id}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveExistingSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					this.isButtonDisabled = false;
					this.saving = false;
					this.loaded = false;
					Vue.prototype.$bus.$emit("error:network", {error:error,submitted:t.getRawValue()});
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},

		SaveExistingSuccess() {
			// TODO: Show thank you message?
			this.user.SetErrors({});
		},

		SaveNewSuccess() {
			// TODO: Show thank you message?
			// this.user.SetErrors({});
			// Start a new lane closure request?
		},

		validateFields() {
			let flag = true;
			flag = this.user.validate();
			return flag;
		},

			// Loads user data into the component based on provided id.
			GetCreateAccountInfo() {
				if (this.jwt) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/create-account-info/?jwt=" + this.jwt + "&r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.user = new CreateAccount(response.data);
						this.loaded = true;
					}).catch(error => {
						this.isButtonDisabled = false;
						this.saving = false;
								this.loaded = false;
						// Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
						this.showErrors(error);

					});
				}
			},
		updatePasswordStrength(password) {
			let has_number    = /\d/.test(password);
			let has_lowercase = /[a-z]/.test(password);
			let has_uppercase = /[A-Z]/.test(password);
			let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
			let strength = 0;
			if (has_number) {
				strength++;
			}
			if (has_lowercase) {
				strength++;
			}
			if (has_uppercase) {
				strength++;
			}
			if (has_special) {
				strength++;
			}
			if (password.length < 8) {
				strength = 0;
			}
			this.passwordStrength = strength;
		}
	}, // end of methods();
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>